import lPrompt from '@/components/l-prompt'
import { lLoading } from '@/components/l-loading'
import LHTTP from '@dayuan/service-http'
import { goPage } from '@/utils/bridge'
import version from '@/utils/version'
const baseApi = '/api'

export default class HTTP extends LHTTP {
  constructor() {
    super({
      options: {
        baseApi: baseApi,
        timeout: 60000,
      },
      defaultHeaders: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
    })
  }

  request(config) {
    // 获取最新的token
    let user = localStorage.getItem(window.$USERKEY || 'USER')
      ? JSON.parse(localStorage.getItem(window.$USERKEY || 'USER'))
      : ''
    if (config.headers) {
      config.headers.token = user ? user.token : ''
      config.headers.source = user.source || process.env.VUE_APP_TYPE
    } else {
      config.headers = {
        token: user ? user.token : '',
        source: user.source || process.env.VUE_APP_TYPE,
      }
    }

    return new Promise((resolve, reject) => {
      lLoading.show('数据加载...')

      this.service(config)
        .then((res) => {
          lLoading.hide()
          if (res.status === this.HTTPSTATUS.SUCCESS) {
            resolve(res)
          } else if (
            res.status === this.HTTPSTATUS.TOKEN_EXPIRED ||
            res.status === this.HTTPSTATUS.USER_NON_LOGIN
          ) {
            lPrompt({
              message: res.msg,
              successTxt: 'OK',
              successFn: function () {
                localStorage.removeItem('USER')
                // -----START--------app内嵌加入代码
                if (version.isLILYTribeAPP()) {
                  goPage(goPage.PageName.LOGIN) // 重新登录
                } else {
                  // -----END--------app内嵌加入代码
                  window.$dayuan1997.login(
                    encodeURIComponent(
                      window.location.protocol + '//' + window.location.host
                    )
                  )
                }
              },
            })
          } else if (res.status === this.HTTPSTATUS.LEARN_UPLOAD_ALREADY) {
            lPrompt({
              message: res.msg,
              successTxt: 'OK',
              successFn: function () {
                localStorage.removeItem('questionEnd')
              },
            })
          } else if (res.status === this.HTTPSTATUS.ROLE_DISABLED) {
            lPrompt({
              message: res.msg,
              successTxt: '确定',
              successFn: function () {
                localStorage.removeItem('USER')
                // -----START--------app内嵌加入代码
                if (version.isLILYTribeAPP()) {
                  goPage(goPage.PageName.LOGIN) // 重新登录
                } else {
                  // -----END--------app内嵌加入代码
                  window.$dayuan1997.login(
                    encodeURIComponent(
                      window.location.protocol + '//' + window.location.host
                    )
                  )
                }
              },
            })
          } else {
            reject(res)
          }
        })
        .catch((error) => {
          lLoading.hide()
          lPrompt({
            message: error.message,
            successTxt: '确定',
            successFn: function () {
              // location.reload()
            },
          })
          reject(null)
        })
    })
  }
}
